<template>
    <div>
        <div class="qrcode-container">
            <canvas ref="qrcode"></canvas>
        </div>
    </div>
</template>

<script>
    import QRCode from 'qrcode';

    export default {
        name: 'QRCodeComponent',
        props: {
            link: {
                type: String,
                required: true,
            },
            size: {
                type: Number,
                required: false,
                default: 200,
            },
            logo: {
                type: String,
                required: false,
                default: '/img/icons/android-chrome-512x512.png',
            },
        },
        mounted() {
            this.generateQRCode();
        },
        methods: {
            async generateQRCode() {
                try {
                    const canvas = this.$refs.qrcode;
                    const ctx = canvas.getContext('2d');

                    // Set ukuran canvas sesuai prop `size`
                    canvas.width = this.size;
                    canvas.height = this.size;

                    // Bersihkan canvas sebelum menggambar ulang
                    ctx.clearRect(0, 0, canvas.width, canvas.height);

                    // Generate QR Code ke canvas
                    await QRCode.toCanvas(canvas, this.link, {
                        width: this.size, // Gunakan prop `size` untuk ukuran QR Code
                        margin: 2, // Margin di sekitar QR Code
                    });

                    // Gambar background lingkaran putih
                    const logoSize = Math.floor(this.size * 0.15); // Ukuran logo (20% dari ukuran QR Code)
                    const circleRadius = logoSize / 2 + 5; // Radius lingkaran (logo + padding)
                    const x = canvas.width / 2;
                    const y = canvas.height / 2;

                    ctx.beginPath();
                    ctx.arc(x, y, circleRadius, 0, Math.PI * 2); // Buat lingkaran
                    ctx.fillStyle = 'white'; // Warna background lingkaran
                    ctx.fill();

                    // Gambar logo di tengah
                    const logoImg = new Image();
                    logoImg.src = this.logo;
                    logoImg.onload = () => {
                        const logoX = x - logoSize / 2;
                        const logoY = y - logoSize / 2;

                        // Gambar logo di tengah canvas dengan ukuran yang tepat
                        ctx.drawImage(
                            logoImg,
                            logoX,
                            logoY,
                            logoSize,
                            logoSize
                        );
                    };
                } catch (error) {
                    console.error('Error generating QR Code:', error);
                }
            },
        },
        watch: {
            link() {
                // Jika link berubah, generate ulang QR Code
                this.generateQRCode();
            },
            logo() {
                // Jika logo berubah, generate ulang QR Code
                this.generateQRCode();
            },
            size() {
                // Jika size berubah, generate ulang QR Code
                this.generateQRCode();
            },
        },
    };
</script>

<style scoped>
    .qrcode-container {
        position: relative;
        margin: 0 auto;
    }
</style>
